const { popper } = require('@popperjs/core');

import $ from 'jquery';
window.$ = window.jQuery = $;
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
import Glide from '@glidejs/glide';
window.Glide = Glide;